module.exports = __webpack_public_path__ + "ph.ba51f2ba.svg";